<template>
    <v-expansion-panel :key="index" hide-actions class="pa-0">
        <v-expansion-panel-header class="pa-0 px-3">
            <div class="d-flex align-center flex-column flex-md-row">
           
                <v-row class="d-flex my-3 mx-6">
                    
                    <v-col>
                        <div class="text-caption">00/00/0000 às 00:00</div>
                        <div class="text-p"><strong>Pedido #221.907-02</strong></div>
                    </v-col>
                    <v-col>
                        <div class="d-flex align-center">
                            <v-icon color="#000">mdi-file-document-outline</v-icon>
                            <div class="ml-3">
                                <div class="text-caption">Formato:</div>
                                <div class="text-p">Branded Content Publieditorial</div>
                            </div>
                        </div>
                    </v-col>
                    <v-col>
                        <div class="d-flex align-center">
                            <v-icon color="#000">mdi-tag-outline</v-icon>
                            <div class="ml-3">
                                <div class="text-caption">Valor:</div>
                                <div class="text-p">R$ 7.400,00</div>
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <v-divider  class="d-flex d-sm-none"></v-divider>
                <v-divider vertical outer-width="100" class="d-none d-sm-flex"></v-divider>
                <div class="d-flex justify-center align-center pa-3 ">
                    Aguardando pagamento
                </div>
               
            </div>

        </v-expansion-panel-header>
        <v-expansion-panel-content class="pa-0">
            <v-divider></v-divider>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>
<script>
    export default {
        name: 'OrderItem',
        props: {
            index: Number
        }
    }
</script>